export function formatBlacklistErrorMessage(message) {
	return String(message).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * Parse axios-style API error payloads into user-facing message arrays.
 * Returns null when the response exists but has no errors body (caller may log/report).
 */
export function parseApiResponseErrors(error, defaultMessage) {
	if (!error.response) {
		return [defaultMessage];
	}

	if (error.response.status === 451 && error.response.data?.errors?.message) {
		return [formatBlacklistErrorMessage(error.response.data.errors.message)];
	}

	if (!error.response.data?.errors) {
		return null;
	}

	const errorMessages = Object.values(error.response.data.errors).flatMap(value =>
		Array.isArray(value) ? value : [value]
	).filter(value => value !== null && value !== undefined && value !== '');

	if (errorMessages.length <= 0) {
		return [defaultMessage];
	}

	return errorMessages;
}
